import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// hooks
import { useCurrentTable } from 'hooks/risks'
import { getMaxHeight } from '../../../hooks/useRowOffset'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
// views
import { PlaceholderWrapper, PlaceholderRow } from './views'
import { OuterWrapper } from '../../../Rows/components/Row/views'
// utils
import { getRowColor } from '../../../utils'
// constants
import { Forms } from 'constants/index'

const templateSelector = formValueSelector(Forms.RISK_TEMPLATE_FORM)

interface Props {
  columnId: string
}

const ColumnPlaceholder: React.FC<Props> = ({ columnId }) => {
  const { rowHeights } = useCurrentTable()
  const { riskSelector } = React.useContext(RiskViewContext)

  const values: any[] = useSelector((state) => (riskSelector || templateSelector)(state, columnId)) ?? []

  return (
    <PlaceholderWrapper>
      {values.map((value, idx) => {
        const group = rowHeights[value?.fieldValueId]
        const rowHeight = group?.[value?.fieldValueId] ?? 0
        const offset = Math.max(0, getMaxHeight(group) - rowHeight)

        return (
          <OuterWrapper key={value?.fieldValueId ?? idx} $bg={getRowColor(idx)}>
            <PlaceholderRow $height={rowHeight} $offset={offset} />
          </OuterWrapper>
        )
      })}
    </PlaceholderWrapper>
  )
}

export default ColumnPlaceholder
